var api = require("!C:\\Users\\vinod\\AppData\\Local\\Yarn\\Data\\global\\node_modules\\style-loader\\dist\\runtime\\injectStylesIntoStyleTag.js");
            var content = require("!!C:\\Users\\vinod\\AppData\\Local\\Yarn\\Data\\global\\node_modules\\css-loader\\dist\\cjs.js!./index.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};